export default __webpack_public_path__ + "static/media/cp-loanInfo.698ff454.png";